import React, { useState } from 'react';
import styles from './ProductAttributesModal.module.css';

const ProductAttributesModal = ({ attributes, setAttributes, onClose, productId }) => {
  const [newAttrName, setNewAttrName] = useState('');
  const [newAttrValue, setNewAttrValue] = useState('');

  const handleAddAttribute = () => {
    if (!newAttrName.trim() || !newAttrValue.trim()) return;
    
    // Agregar el atributo al estado local (se guardará cuando se envíe el formulario principal)
    setAttributes([...attributes, { name: newAttrName.trim(), value: newAttrValue.trim() }]);
    setNewAttrName('');
    setNewAttrValue('');
  };

  const handleValueChange = (idx, value) => {
    const updated = [...attributes];
    updated[idx].value = value;
    setAttributes(updated);
  };

  const handleRemove = (idx) => {
    const updated = [...attributes];
    updated.splice(idx, 1);
    setAttributes(updated);
  };

  // Solo cierra el modal, no guarda en la base de datos
  const handleSave = () => {
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>Atributos personalizados</h2>
        <div className={styles.attrList}>
          {attributes.map((attr, idx) => (
            <div key={idx} className={styles.attrRow}>
              <span className={styles.attrName}>{attr.name}</span>
              <input
                value={attr.value}
                onChange={e => handleValueChange(idx, e.target.value)}
                className={styles.attrValue}
              />
              <button className={styles.removeBtn} onClick={() => handleRemove(idx)}>✖</button>
            </div>
          ))}
        </div>
        <div className={styles.addAttrRow}>
          <input
            placeholder="Nombre del atributo"
            value={newAttrName}
            onChange={e => setNewAttrName(e.target.value)}
            className={styles.attrName}
          />
          <input
            placeholder="Valor"
            value={newAttrValue}
            onChange={e => setNewAttrValue(e.target.value)}
            className={styles.attrValue}
          />
          <button className={styles.addBtn} onClick={handleAddAttribute}>Agregar</button>
        </div>
        <div className={styles.modalActions}>
          <button className={styles.saveBtn} type="button" onClick={handleSave}>Guardar</button>
          <button className={styles.cancelBtn} type="button" onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default ProductAttributesModal;